import { UAParser             } from 'ua-parser-js';

import { v4 as uuidv4         } from 'uuid';

import { encode,
         decode               } from 'base64-arraybuffer';

import { decode as tifDecode,
         decodeImage,
         toRGBA8              } from 'utif2';

import * as types               from 'src/services/api/types';

import { Nullable             } from 'src/common';



const EMPTY_MASK = '+ _ ___ ___ __ __';
const RUS_MASK = '+# ###-###-##-##';
const LVA_MASK = '+(###) ##-######';
const BLR_MASK = '+(###) ##-###-##-##';
const UZB_MASK = '+(###) ##-###-##-##';
const AZN_MASK = '+(###) ##-###-##-##';
const ARM_MASK = '+(###) ##-###-##-##';
const TJK_MASK = '+(###) ##-###-##-##';
const GEO_MASK = '+(###) #######-##';
const TKM_MASK = '+(###) #######-##';

const RUS_CODE = '7';
const LVA_CODE = '371';
const BLR_CODE = '375';
const UZB_CODE = '998';
const AZN_CODE = '994';
const ARM_CODE = '374';
const TJK_CODE = '992';
const GEO_CODE = '995';
const TKM_CODE = '993';

const RUS_LEN = 11;
const LVA_LEN = 11;
const BLR_LEN = 12;
const UZB_LEN = 12;
const AZN_LEN = 12;
const ARM_LEN = 12;
const TJK_LEN = 12;
const GEO_LEN = 12;
const TKM_LEN = 12;

class Util {
  get appModel(): string {
    const ua = new UAParser();
    const OS = ua.getOS();
    const BROWSER = ua.getBrowser();
    return `checksteel-pwa:${OS.name} ${OS.version} ${BROWSER.name} ${BROWSER.version}`.replaceAll(' ', '_');
  }

  get currentTS(): number {
    return Math.floor(Date.now() / 1000);
  }

  get noPhoto(): string {
    return 'data:image/png;base64,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';
  }

  dateFormat(date: Date, format: string): string {
    const YYYY = `${date.getFullYear()}`;
    const MM = `${date.getMonth() + 1}`.padStart(2, '0');
    const DD = `${date.getDate()}`.padStart(2, '0');
    const hh = `${date.getHours()}`.padStart(2, '0');
    const mm = `${date.getMinutes()}`.padStart(2, '0');
    const ss = `${date.getSeconds()}`.padStart(2, '0');

    return format.replaceAll('YYYY', YYYY)
                 .replaceAll('MM', MM)
                 .replaceAll('DD', DD)
                 .replaceAll('hh', hh)
                 .replaceAll('mm', mm)
                 .replaceAll('ss', ss);
  }

  fromStringToDateFormat(dateStr: string, format: string): Date {
    let YYYY = 0;
    let MM = 0;
    let DD = 0;
    let hh = 0;
    let mm = 0;
    let ss = 0;

    if (format.includes('YYYY'))
    {
      const iYYYY = format.indexOf('YYYY');
      YYYY = parseInt(dateStr.substring(iYYYY, iYYYY + 4), 10);
    }

    if (format.includes('MM'))
    {
      const iMM = format.indexOf('MM');
      MM = parseInt(dateStr.substring(iMM, iMM + 2), 10) - 1;
    }

    if (format.includes('DD'))
    {
      const iDD = format.indexOf('DD');
      DD = parseInt(dateStr.substring(iDD, iDD + 2), 10);
    }

    if (format.includes('hh'))
    {
      const ihh = format.indexOf('hh');
      hh = parseInt(dateStr.substring(ihh, ihh + 2), 10);
    }

    if (format.includes('mm'))
    {
      const imm = format.indexOf('mm');
      mm = parseInt(dateStr.substring(imm, imm + 2), 10);
    }

    if (format.includes('ss'))
    {
      const iss = format.indexOf('ss');
      ss = parseInt(dateStr.substring(iss, iss + 2), 10);
    }

    return new Date(YYYY, MM, DD, hh, mm, ss);
  }

  // Акцкой костыль из-за того, что сервер манипулирует переданными timestamp-ами, поэтому иногда надо прибавлять
  // 3 часа, иногда отнимать.
  plusMoscowTimezone(timestamp: number): number {
    return timestamp + 3 * 60 * 60 * 1000;
  }

  isEmailCorrect(email: string): boolean {
    const regex = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$');

    return regex.test(email);
  }

  inInclusiveRange(inclusiveMin: number, inclusiveMax: number, value: number): boolean
  {
    return value >= inclusiveMin && value <= inclusiveMax;
  }

  arrayBufferToBase64(ab: ArrayBuffer): string {
    return encode(ab);
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    return decode(base64);
  }

  selectDigitsFromString(value: string): string {
    return value
      .split('')
      .filter((char) => '0123456789'.includes(char))
      .join('');
  }

  selectDigitsWithLimitFromString(value: string, limit: number): string {
    return value
      .split('')
      .filter((char) => '0123456789'.includes(char))
      .join('')
      .substring(0, limit);
  }


  /** Три цифры после точки */
  selectDigitsAndDotFromString3(rawValue: string): string {
    /** Заменяем запятую на точку */
    const value = rawValue.replaceAll(',', '.');

    if (value === '.')
    {
      return '';
    }

    if (value.length === 2 && value.startsWith('0') && !value.endsWith('.'))
    {
      return '0';
    }

    return value
      .split('')
      .filter((char) => '0123456789.'.includes(char))
      .reduce((acc, val) => {
        return val !== '.' ? 
          (acc.includes('.') ? (acc.length - acc.indexOf('.') > 3 ? acc : `${acc}${val}`) : `${acc}${val}`)
          :
          ((acc.includes('.') ? acc : `${acc}${val}`));
      }, '');
  }

  /** Максимум N цифр до запятой и M цифр после */
  selectDigitsAndDotFromStringN_M(rawValue: string, n: number, m: number): string {
    const value = rawValue
      .replaceAll(",", ".")
      .split("")
      .filter((char) => "0123456789.".includes(char))
      .reduce(
        (acc, v) => (v !== "." || !acc.includes(".") ? `${acc}${v}` : acc),
        ""
      );

    if (value === "" || value === ".") {
      return "";
    }

    const parts = value.split(".");
    let beforeDot = parts.length > 0 ? parts[0] : "";
    let afterDot = parts.length > 1 ? parts[1] : "";

    if (beforeDot.startsWith("0") && beforeDot.length > 1) {
      beforeDot = "0";
    }

    beforeDot = beforeDot.substring(0, n);

    if (afterDot.length > 0) {
      afterDot = afterDot.substring(0, m);
    }

    return `${beforeDot}${value.includes(".") ? `.${afterDot}` : ""}`;
  }

  selectPercentFromString(rawValue: string): string {
    if (rawValue === '100.' || rawValue === '100,') {
      return '100';
    }

    const transformedValue = this.selectDigitsAndDotFromStringN_M(rawValue, 3, 2);
    
    if (transformedValue.length > 0 && parseFloat(transformedValue) > 100)
    {
      return '100';
    }

    return transformedValue;
  }

  selectHeatAllowedCharsFromString(value: string): string {
    return value
      .toUpperCase()
      .split('')
      .filter((char) => 'ABCDEFGHIJKLMNOPQRSTUVWXYZАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЫЪЭЮЯ0123456789-/'.includes(char))
      .join('');
  }

  selectLatinAlphaNumbericFromString(value: string): string {
    return value
      .split('')
      .filter((char) => 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789'.includes(char))
      .join('');
  }

  selectRollNumberFromString(value: string): string {
    return value
      .split('')
      .filter((char) => '0123456789'.includes(char))
      .join('')
      .substring(0, 8)
      .split('')
      .reduce((acc, char) => acc.length === 6 ? `${acc} ${char}` : `${acc}${char}`, '');
  }

  stringContainsDigit(value: string): boolean {
    return value
      .split('')
      .some((char) => '0123456789'.includes(char));
  }

  stringContainsUpperCaseChar(value: string): boolean {
    return value
      .split('')
      .some(
        (char) => 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz'.includes(char) && char === char.toUpperCase()
      );
  }

  timeHHMM(value: Date): string {
    const hh = `${value.getHours()}`.padStart(2, '0');
    const mm = `${value.getMinutes()}`.padStart(2, '0');
    
    return `${hh}:${mm}`;
  }

  beginDay(value: Date): Date {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0);
  }

  endDay(value: Date): Date {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), 23, 59, 59);
  }

  getPhoneMaskEmpty(): string {
    return EMPTY_MASK;
  }

  getPhoneMaskByNumber(phone: string): string {
    if (phone.startsWith(LVA_CODE))
    {
      return LVA_MASK;
    }

    if (phone.startsWith(BLR_CODE))
    {
      return BLR_MASK;
    }

    if (phone.startsWith(UZB_CODE))
    {
      return UZB_MASK;
    }

    if (phone.startsWith(AZN_CODE))
    {
      return AZN_MASK;
    }

    if (phone.startsWith(ARM_CODE))
    {
      return ARM_MASK;
    }

    if (phone.startsWith(TJK_CODE))
    {
      return TJK_MASK;
    }

    if (phone.startsWith(GEO_CODE))
    {
      return GEO_MASK;
    }

    if (phone.startsWith(TKM_CODE))
    {
      return TKM_MASK;
    }

    return RUS_MASK;
  }

  isPhoneValid(phoneWithoutPlus: string): boolean {
    return (phoneWithoutPlus.startsWith(RUS_CODE) && phoneWithoutPlus.length === RUS_LEN)
           ||
           (phoneWithoutPlus.startsWith(LVA_CODE) && phoneWithoutPlus.length === LVA_LEN)
           ||
           (phoneWithoutPlus.startsWith(BLR_CODE) && phoneWithoutPlus.length === BLR_LEN)
           ||
           (phoneWithoutPlus.startsWith(UZB_CODE) && phoneWithoutPlus.length === UZB_LEN)
           ||
           (phoneWithoutPlus.startsWith(AZN_CODE) && phoneWithoutPlus.length === AZN_LEN)
           ||
           (phoneWithoutPlus.startsWith(ARM_CODE) && phoneWithoutPlus.length === ARM_LEN)
           ||
           (phoneWithoutPlus.startsWith(TJK_CODE) && phoneWithoutPlus.length === TJK_LEN)
           ||
           (phoneWithoutPlus.startsWith(GEO_CODE) && phoneWithoutPlus.length === GEO_LEN)
           ||
           (phoneWithoutPlus.startsWith(TKM_CODE) && phoneWithoutPlus.length === TKM_LEN)
  }

  getPhoneErrorForValidator(phoneWithoutPlus: string): string {
    if (phoneWithoutPlus.startsWith(RUS_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== RUS_LEN,
        () => `Российский номер телефона должен содержать ${RUS_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(LVA_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== LVA_LEN,
        () => `Латвийский номер телефона должен содержать ${LVA_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(BLR_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== BLR_LEN,
        () => `Белорусский номер телефона должен содержать ${BLR_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(UZB_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== UZB_LEN,
        () => `Узбекский номер телефона должен содержать ${UZB_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(AZN_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== AZN_LEN,
        () => `Азербайджанский номер телефона должен содержать ${AZN_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(ARM_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== ARM_LEN,
        () => `Армянский номер телефона должен содержать ${ARM_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(TJK_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== TJK_LEN,
        () => `Таджикский номер телефона должен содержать ${TJK_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(GEO_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== GEO_LEN,
        () => `Грузинский номер телефона должен содержать ${GEO_LEN} цифр`,
        () => ''
      );
    }

    if (phoneWithoutPlus.startsWith(TKM_CODE))
    {
      return this.terOp<string>(
        phoneWithoutPlus.length !== TKM_LEN,
        () => `Туркменский номер телефона должен содержать ${TKM_LEN} цифр`,
        () => ''
      );
    }

    return 'Неизвестный номер телефона';
  }

  normalizePhone(value: string): number {
    return parseInt(this.selectDigitsFromString(value).padStart(11, '7'), 10);
  }

  formatPhone(phone: number): string {
    const P = `${phone}`;
    return `+${P[0]} (${P.substring(1, 4)}) ${P.substring(4, 7)}-${P.substring(7, 9)}-${P.substring(9)}`;
  }

  guid(withoutSeparatorsAndUpperCase: boolean): string {
    if (withoutSeparatorsAndUpperCase)
    {
      return uuidv4().replaceAll('-', '').toUpperCase();
    }

    return uuidv4();
  }

  buildPieceAttachmentName(attachmentType: types.inspection.PieceFileType, originalName: string): string {
    const now = new Date();
    const DF = this.dateFormat(now, 'YYYYMMDD_hhmmss');
    const GF = uuidv4().substring(0, 5);
    const originalNameLower = originalName.toLowerCase();
    const isTIF = originalNameLower.endsWith('.tif') || originalNameLower.endsWith('.tiff');
    
    switch (attachmentType)
    {
      case types.inspection.PieceFileType.GENERAL:
        return `Фото_общего_вида_DATE_GUID_pwa.${isTIF ? 'tif' : 'jpg'}`.replaceAll('DATE', DF).replaceAll('GUID', GF);
      case types.inspection.PieceFileType.PHOTO:
        return `Фото_DATE_GUID_pwa.${isTIF ? 'tif' : 'jpg'}`.replaceAll('DATE', DF).replaceAll('GUID', GF);
      case types.inspection.PieceFileType.PDF:
        const rawName = originalName.substring(0, originalName.lastIndexOf('.'));
        const shortName = rawName.substring(0, Math.min(rawName.length, 25)).trim().replaceAll('.', '_').replaceAll(' ', '_');
        return `NAME_DATE_GUID_pwa.${this.getFileExt(originalName)}`
          .replaceAll('NAME', shortName)
          .replaceAll('DATE', DF)
          .replaceAll('GUID', GF);
    }
  }

  buildDefectAttachmentName(attachmentType: types.inspection.DefectFileType, originalName: string): string {
    const now = new Date();
    const DF = this.dateFormat(now, 'YYYYMMDD_hhmmss');
    const GF = uuidv4().substring(0, 5);
    
    switch (attachmentType)
    {
      case types.inspection.DefectFileType.ACT_JOIN_INSP:
      case types.inspection.DefectFileType.ADDITIONAL_COSTS:
        const rawName = originalName.substring(0, originalName.lastIndexOf('.'));
        const shortName = rawName.substring(0, Math.min(rawName.length, 25)).trim().replaceAll('.', '_').replaceAll(' ', '_');
        return `NAME_DATE_GUID_pwa.${this.getFileExt(originalName)}`
          .replaceAll('NAME', shortName)
          .replaceAll('DATE', DF)
          .replaceAll('GUID', GF);
    }
  }

  getFileExt(fileName: string): string {
    const parts = fileName.split('.');

    if (parts.length === 1)
    {
      return '';
    }

    return parts[parts.length - 1];
  }

  checkFileTypeByExt(fileName: string): 'JPG' | 'JFIF' | 'BMP' | 'PNG' | 'WEBP' | 'HEIC' | 'TIF' | 'PDF' | 'XLSX' | 'UNK' {
    const fileExt = this.getFileExt(fileName);

    if (fileExt === '')
    {
      return 'UNK';
    }

    switch (fileExt.toUpperCase())
    {
      case 'BMP':
        return 'BMP';
      case 'JPG':
      case 'JPEG':
        return 'JPG';
      case 'JFIF':
        return 'JFIF';
      case 'PNG':
        return 'PNG';
      case 'WEBP':
        return 'WEBP';
      case 'HEIC':
        return 'HEIC';
      case 'TIF':
      case 'TIFF':
        return 'TIF';
      case 'PDF':
        return 'PDF';
      case 'XLSX':
        return 'XLSX';
      default:
        return 'UNK';
    }
  }

  async checkFileTypeByHeader(
    file: File
  ): Promise<
    'JPG' | 'JFIF' | 'BMP' | 'PNG' | 'WEBP' | 'HEIC' | 'TIF' | 'PDF' | 'XLSX' | 'UNK'
  > {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = (event) => {
        if (event.target === null || event.target.result === null) {
          return resolve("UNK");
        }

        const buffer = new Uint8Array(event.target.result as ArrayBuffer);

        if (file.name.toLocaleUpperCase().endsWith(".HEIC")) {
          const ftyp = buffer
            .subarray(4, 8)
            .reduce((a, v) => `${a}${v.toString(16).padStart(2, "0")}`, "");
          const brand = buffer
            .subarray(8, 12)
            .reduce((a, v) => `${a}${v.toString(16).padStart(2, "0")}`, "");

          const brands = [
            "68656963", // 'heic': the usual HEIF images
            "68656978", // 'heix': 10bit images, or anything that uses h265 with range extension
            "68657663", // 'hevc': brands for image sequences
            "68657678", // 'hevx': brands for image sequences
            "6865696d", // 'heim': multiview
            "68656973", // 'heis': scalable
            "6865766d", // 'hevm': multiview sequence
            "68657673", // 'hevs': scalable sequence
          ];

          if (ftyp === "66747970" && brands.includes(brand)) {
            return resolve("HEIC");
          }

          return resolve("UNK");
        }

        const header = buffer
          .subarray(0, 4)
          .reduce((a, v) => `${a}${v.toString(16).padStart(2, "0")}`, "");

        // JPEG: все варианты начинаются с FF D8 FF, 4-й байт (маркер) различается
        if (header.startsWith("ffd8ff")) {
          return resolve(header === "ffd8ffe0" ? "JFIF" : "JPG");
        }

        switch (header) {
          case "424d228c":
          case "424d8240":
          case "424d8e1b":
            return resolve("BMP");
          case "89504e47":
            return resolve("PNG");
          case "52494646":
            return resolve("WEBP");
          case "49492a00":
          case "4d4d002a":
            return resolve("TIF");
          case "25504446":
            return resolve("PDF");
          case "504b0304":
            return resolve("XLSX");
          default:
            return resolve("UNK");
        }
      };

      reader.onerror = () => {
        resolve("UNK");
      };

      reader.readAsArrayBuffer(file);
    });
  }

  async fileToDataURL(file: File): Promise<{ ok: boolean; result: string; }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          resolve({ ok: true, result: reader.result as string });
        },
        false,
      );

      reader.readAsDataURL(file);
    })
  }

  async imageToDataURL(file: File): Promise<{ ok: boolean; result: string; }> {
    return new Promise((resolve, _) => {
      if (!file.type.match(/image.*/))
      {
        return resolve({
          ok: false,
          result: 'Файл не является изображением',
        });
      }

      const isTIF = file.type === 'image/tiff';

      const reader = new FileReader();

      reader.onload = (readerEvent) => {
        if (isTIF)
        {
          const rawData = readerEvent.target?.result as ArrayBuffer;
          const ifds = tifDecode(rawData);

          let cvWidth = 0;
          let cvHeight = 0;

          ifds.forEach((ifd) => {
            decodeImage(rawData, ifd);
            cvHeight += ifd.height;
            cvWidth = Math.max(cvWidth, ifd.width);
          });

          const canvas = document.createElement('canvas');
          canvas.width = cvWidth;
          canvas.height = cvHeight;
          const context = canvas.getContext('2d');

          if (context === null)
          {
            return resolve({
              ok: false,
              result: 'Внутренния ошибка при подготовке изображения',
            });
          }

          let cHeight = 0;

          ifds.forEach((ifd) => {
            const uac = new Uint8ClampedArray(toRGBA8(ifd), ifd.width, ifd.height);
            const iData = new ImageData(uac, ifd.width, ifd.height);
                      
            context.putImageData(iData, 0, cHeight);
            cHeight += ifd.height;
          });

          const dataUrl = canvas.toDataURL('image/jpeg');

          return resolve({
            ok: true,
            result: dataUrl,
          });
        }
        else
        {
          const image = new Image();

          image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');

            if (context === null)
            {
              return resolve({
                ok: false,
                result: 'Внутренния ошибка при подготовке изображения',
              });
            }

            context.drawImage(image, 0, 0, canvas.width, canvas.height);

            const dataUrl = canvas.toDataURL('image/jpeg');

            return resolve({
              ok: true,
              result: dataUrl,
            });
          };

          image.onerror = (ev) => {
            resolve({
              ok: false,
              result: 'Файл не является изображением',
            });
          };

          image.src = (readerEvent.target?.result as string) || '';
        }
      };

      reader.onerror = () => {
        resolve({
          ok: false,
          result: 'Внутренния ошибка при подготовке изображения',
        });
      };

      isTIF ? reader.readAsArrayBuffer(file) : reader.readAsDataURL(file);
    });
  }

  async fileToBinaryString(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = () => reject();
      reader.readAsBinaryString(file);
    });
  }

  async binaryStringToFile(binary: string, name: string, mime: string): Promise<File> {
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++)
    {
      array[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([array]);
    const file = new File([blob], name, { type: mime });

    return file;
  }

  async blobToFile(blob: Blob, name: string, mime: string): Promise<File> {
    const file = new File([blob], name, { type: mime });

    return file;
  }

  dataURLToFile(dataURL: string, fileName: string): File {
    const BASE64_MARKER = ";base64,";

    const parts = dataURL.split(BASE64_MARKER);
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;

    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new File([new Blob([uInt8Array], { type: contentType })], fileName, {
      type: contentType,
    });
  }

  async resizeIfImage(file: File, lenByBiggestSize: number): Promise<File> {
    return new Promise((resolve, _) => {
      if (!file.type.match(/image.*/)) {
        return resolve(file);
      }

      const reader = new FileReader();

      reader.onload = (readerEvent) => {
        const image = new Image();

        image.onload = () => {
          const iWidth = image.width;
          const iHeight = image.height;
          const lenByBiggestSizeCorrect = Math.min(lenByBiggestSize, Math.max(iWidth, iHeight));

          const canvas = document.createElement("canvas");
          canvas.width =
            iWidth > iHeight
              ? lenByBiggestSizeCorrect
              : Math.ceil((lenByBiggestSizeCorrect * iWidth) / iHeight);
          canvas.height =
            iHeight > iWidth
              ? lenByBiggestSizeCorrect
              : Math.ceil((lenByBiggestSizeCorrect * iHeight) / iWidth);
          const context = canvas.getContext("2d");

          if (context === null) {
            return resolve(file);
          }

          context.drawImage(image, 0, 0, canvas.width, canvas.height);

          const dataUrl = canvas.toDataURL("image/jpeg");
          const resizedImage = this.dataURLToFile(dataUrl, file.name);

          return resolve(resizedImage);
        };

        image.onerror = () => {
          resolve(file);
        };

        image.src = (readerEvent.target?.result as string) || "";
      };

      reader.onerror = () => {
        resolve(file);
      };

      reader.readAsDataURL(file);
    });
  }

  nullOrEmptyStringTo(value: Nullable<string> | undefined, to: string): string {
    if (value === null || value === undefined || value.trim() === '')
    {
      return to;
    }

    return value.trim();
  }

  nullOrZeroNumberTo(value: Nullable<number> | undefined, to: number): number {
    if (value === null || value === undefined || value === 0)
    {
      return to;
    }

    return value;
  }

  notNull(values: any[]): boolean {
    return values.every((item) => item !== null);
  }

  shadeSelectionReportName(primaryRoll: string, date: number): string {
    const dt = new Date(date);

    return `Результат_${primaryRoll.replace(' ', '_')}_${dt.toLocaleDateString()}_${this.timeHHMM(dt).replace(':', '_')}.xlsx`;
  }

  countDigitsBeforeDot(value: string): number {
    return `${value.replaceAll(",", ".")}.`.indexOf(".");
  }

  isNotContractor(role: types.auth.AccountRole): boolean {
    return role !== types.auth.AccountRole.Contractor;
  }

  isQualityOrService(defectType: Nullable<types.inspection.DefectType>): boolean {
    const { QUALITY, SERVICE } = types.inspection.DefectType;
    return defectType === null || defectType === QUALITY || defectType === SERVICE;
  }

  isInspectionNotCompleted(inspectionState: types.inspection.InspectionState): boolean {
    const { CREATE, DRAFT, ERROR, NEW} = types.inspection.InspectionState;
    return [CREATE, DRAFT, ERROR, NEW].includes(inspectionState);
  }

  terOp<T>(condition: boolean, trueResult: () => T, falseResult: () => T): T { return condition ? trueResult() : falseResult() }
}

const instance = new Util();
export default instance;